var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Controller } from "@hotwired/stimulus";
export default class comment_feedbacks_controller_default extends Controller {
  connect() {
    this.injectAll();
    this.boundInject = this.injectAll.bind(this);
    document.addEventListener("comments:loaded", this.boundInject);
    this.observer = new MutationObserver(() => this.injectAll());
    this.observer.observe(this.element, { childList: true, subtree: true });
  }
  disconnect() {
    if (this.boundInject) document.removeEventListener("comments:loaded", this.boundInject);
    if (this.observer) this.observer.disconnect();
  }
  injectAll() {
    this.feedbackTargets.forEach((tpl) => this.inject(tpl));
  }
  inject(template) {
    const commentId = template.dataset.commentId;
    if (!commentId) return;
    const host = this.element.querySelector(`#comment_${commentId}`);
    if (!host) return;
    if (host.querySelector(`.pt-feedback-status[data-comment-id="${commentId}"]`)) return;
    const fragment = template.content.cloneNode(true);
    const statusEl = fragment.querySelector('[data-comment-feedbacks-role="status"]');
    const bodyEl = fragment.querySelector('[data-comment-feedbacks-role="body"]');
    if (statusEl) this.placeStatus(host, statusEl);
    if (bodyEl) host.appendChild(bodyEl);
  }
  placeStatus(host, statusEl) {
    const header = host.querySelector(".comment__header");
    if (header) {
      const menu = header.querySelector(".relative.ml-auto, .ml-auto");
      if (menu) header.insertBefore(statusEl, menu);
      else header.appendChild(statusEl);
    } else {
      host.appendChild(statusEl);
    }
  }
}
__publicField(comment_feedbacks_controller_default, "targets", ["feedback"]);
